<template>
  <div class="deprecation-page">
    <p>该域名已弃用，请前往 <a href="https://github.com/sepinetam/mcp-for-stata" target="_blank" rel="noopener noreferrer">https://github.com/sepinetam/mcp-for-stata</a> 查看</p>
    <p>This domain has been deprecated. Please visit <a href="https://github.com/sepinetam/mcp-for-stata" target="_blank" rel="noopener noreferrer">https://github.com/sepinetam/mcp-for-stata</a> for more information.</p>
  </div>
</template>

<style scoped>
.deprecation-page {
  text-align: center;
  padding: 2rem;
  line-height: 2;
  font-size: 1.125rem;
}

.deprecation-page a {
  color: #60a5fa;
  text-decoration: underline;
}

.deprecation-page a:hover {
  color: #93c5fd;
}
</style>
